import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'; 
import DealerModel from "./models/DealerModel";
import DealerModal from "./DealerModal";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";

function DealerGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [dealerModel, setDealerModel] = useState(new DealerModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);

  function closeModal() {
    setIsOpen(false);
    setDealerModel(new DealerModel());
    props.fetchDealers();
  }

  const rows = props.DealerData
    ? props.DealerData.filter(
      (item) =>
        (item.DealerName &&
          item.DealerName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.MobileNumber &&
          item.MobileNumber.toString().toLowerCase().includes(filterText.toLowerCase())) ||
        (item.EmailId &&
          item.EmailId.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    setDealerModel(row);
    setIsOpen(true);
    setActionType(name);
  };
  async function onSubmit(e, data) {
    const dealerModel = data;
    if (e.target.name === "Edit") {
      let dealerDetails = {
        DealerId: dealerModel.DealerId,
        DealerName: dealerModel.DealerName,
        MobileNumber: dealerModel.MobileNumber,
        EmailId: dealerModel.EmailId,
        AddressLine1: dealerModel.AddressLine1,
        AddressLine2: dealerModel.AddressLine2,
        AddressLine3: dealerModel.AddressLine3,
        City: dealerModel.City,
        State: dealerModel.State,
        Country: dealerModel.Country,
        PinNumber: dealerModel.PinNumber,
        UserId: getStorageValues('userId')
      };
      if (validation(dealerDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/dealer/save", 
            dealerDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchDealers();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else if(e.target.name === "Delete"){
      let dealerDetails = {
        DealerId: dealerModel.DealerId,
        UserId: getStorageValues('userId')
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/dealer/delete", dealerDetails
        );
        if (response.status === 200) {
          CreateAlert("Dealer deleted successfully!!", "Success", setAlert);
          props.fetchDealers();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  function validation(customerDetails) {
    var validation = true;
    if (customerDetails) {
      if (!customerDetails.DealerName || customerDetails.DealerName.length === 0) {
        CreateAlert("Please enter dealer name!!", "Warning", setAlert);
          validation = false;
      }
    } else {
      CreateAlert("Some problem fetching user details entered by the user!!", "Error", setAlert);
      return (validation = false);
    }
    return validation;
  }

  const columns = [
    {
      name:<div className="titlename"><span>Dealer </span></div> ,
      selector: row => row.DealerName,
      cell: (row) => (
        <span title={row.DealerName}>{row.DealerName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Mobile </span></div>,
      selector: row => row.MobileNumber,
      cell: (row) => (
        <span title={row.MobileNumber}>{row.MobileNumber}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Email </span></div>,
      selector: row => row.EmailId,
      cell: (row) => (
        <span title={row.EmailId}>{row.EmailId}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
  ];
  if(props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1){
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
            props.UserPermissions.ViewModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "View");
                }}
              >
                <Icons.Eye data-feather="eye" className="action-eye" />
              </Link>
            : null
          }
          {
            props.UserPermissions.EditModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Edit");
                }}
              >
                <Icons.Edit data-feather="edit" className="feather-edit" />
              </Link>
            : null
          }
          {
            props.UserPermissions.DeleteModule === 1 ? 
              <Link
                className="confirm-text p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Delete");
                }}
              >
                <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
              </Link>
            : null
          }
        </div>
      ),
      center: "true",
      width: "150px"
    },);
  };

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="DealerName"
            sortIcon={<SortArrow/>}
            persistTableHead={true}
          />
        </div>
      </div>
      <DealerModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={dealerModel}
        onSubmit={onSubmit}
      />
    </>
  );
}

export default DealerGrid;
